import {
  Bitcoin, ShieldCheck, Languages, Sparkles, Wallet, MapPin
} from "lucide-react";

const ITEMS = [
  { i: <Bitcoin size={14}/>, t: "Crypto payments accepted" },
  { i: <ShieldCheck size={14}/>, t: "Verified providers" },
  { i: <Wallet size={14}/>, t: "Protected deposits" },
  { i: <Languages size={14}/>, t: "Multi-language" },
  { i: <Sparkles size={14}/>, t: "AI concierge 24/7" },
  { i: <MapPin size={14}/>, t: "Ibiza" },
  { i: <MapPin size={14}/>, t: "Custom Trip" },
  { i: <MapPin size={14}/>, t: "Mykonos" },
  { i: <MapPin size={14}/>, t: "Dubai" },
  { i: <MapPin size={14}/>, t: "Miami" },
  { i: <MapPin size={14}/>, t: "Tulum" },
  { i: <MapPin size={14}/>, t: "Bali" },
  { i: <MapPin size={14}/>, t: "Marbella" },
  { i: <MapPin size={14}/>, t: "Monaco" },
  { i: <MapPin size={14}/>, t: "Saint-Tropez" },
  { i: <MapPin size={14}/>, t: "Cannes" },
  { i: <MapPin size={14}/>, t: "Courchevel" },
];

function Track() {
  return (
    <div className="flex items-center gap-10 px-5 shrink-0">
      {ITEMS.map((it, k) => (
        <span key={k} className="inline-flex items-center gap-2 text-bone/85">
          <span className="text-teal">{it.i}</span>
          <span className="text-[11px] tracking-widest2 uppercase font-bitcount">{it.t}</span>
          <span className="text-muted/40">·</span>
        </span>
      ))}
    </div>
  );
}

export default function HeroMarquee() {
  return (
    <div className="overflow-hidden border-t hairline backdrop-blur-md bg-ink/45 py-3">
      <div className="flex w-max animate-marquee-smooth">
        <Track />
        <Track />
      </div>
    </div>
  );
}
